import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/Home.vue';

import { actions as actionsGeral } from '@/modules/geral/storeGeral';
import { actions as actionsCandidate } from '@/modules/candidate/storeCandidate';
import { requireAuth, require2025Timer, requireCadastroPerfilTimer } from '@/router/guards';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Início',
    },
  },
  {
    path: '/auth-handler',
    name: 'AuthHandler',
    component: () => import(/* webpackChunkName: "auth-handler" */ '../components/AuthHandler.vue'),
    meta: {
      title: 'Verificando autenticação...',
    },
  },
  {
    path: '/cadastro',
    name: 'Cadastro',
    component: () => import(/* webpackChunkName: "cadastro" */ '../views/cadastro/Cadastro.vue'),
    meta: {
      title: 'Cadastro',
    },
    beforeEnter: [requireAuth, requireCadastroPerfilTimer],
  },
  {
    path: '/perfil',
    name: 'Perfil',
    component: () => import(/* webpackChunkName: "cadastro" */ '../views/Perfil.vue'),
    meta: {
      title: 'Perfil',
    },
    beforeEnter: [requireAuth, requireCadastroPerfilTimer],
  },
  {
    path: '/pre-requisitos-cnh',
    name: 'PreRequisitosCNH',
    component: () => import(/* webpackChunkName: "prerequisitos-cnh" */ '../views/PreRequisitosCNH.vue'),
    meta: {
      title: 'Pré-requisitos CNH',
    },
  },
  {
    path: '/pre-requisitos-motociclista',
    name: 'PreRequisitosMotociclista',
    component: () => import(/* webpackChunkName: "prerequisitos-motociclista" */ '../views/PreRequisitosMoto.vue'),
    meta: {
      title: 'Pré-requisitos Motociclista',
    },
  },
  {
    path: '/selecionados-primeira-fase-cnh',
    name: 'SelecionadosPrimeiraFaseCNH',
    component: () =>
      import(/* webpackChunkName: "SelecionadosPrimeiraFaseCNH" */ '../views/SelecionadosPrimeiraFaseCNH.vue'),
    meta: {
      title: 'Selecionados Primeira Fase CNH Social 2022',
    },
  },
  {
    path: '/selecionados-segunda-fase-cnh',
    name: 'SelecionadosSegundaFaseCNH',
    component: () =>
      import(/* webpackChunkName: "SelecionadosSegundaFaseCNH" */ '../views/SelecionadosSegundaFaseCNH.vue'),
    meta: {
      title: 'Selecionados Segunda Fase CNH Social 2022',
    },
  },
  {
    path: '/selecionados-terceira-fase-cnh',
    name: 'SelecionadosTerceiraFaseCNH',
    component: () =>
      import(/* webpackChunkName: "SelecionadosTerceiraFaseCNH" */ '../views/SelecionadosTerceiraFaseCNH.vue'),
    meta: {
      title: 'Selecionados Terceira Fase CNH Social 2022',
    },
  },
  {
    path: '/selecionados-quarta-fase-cnh',
    name: 'SelecionadosQuartaFaseCNH',
    component: () =>
      import(/* webpackChunkName: "SelecionadosQuartaFaseCNH" */ '../views/SelecionadosQuartaFaseCNH.vue'),
    meta: {
      title: 'Selecionados Quarta Fase CNH Social 2022',
    },
  },
  {
    path: '/selecionados-quinta-fase-cnh',
    name: 'SelecionadosQuintaFaseCNH',
    component: () =>
      import(/* webpackChunkName: "SelecionadosQuintaFaseCNH" */ '../views/SelecionadosQuintaFaseCNH.vue'),
    meta: {
      title: 'Selecionados Quinta Fase CNH Social 2022',
    },
  },
  {
    path: '/selecionados-sexta-fase-cnh',
    name: 'SelecionadosSextaFaseCNH',
    component: () => import(/* webpackChunkName: "SelecionadosSextaFaseCNH" */ '../views/SelecionadosSextaFaseCNH.vue'),
    meta: {
      title: 'Selecionados Sexta Fase CNH Social 2022',
    },
  },
  {
    path: '/selecionados-setima-fase-cnh',
    name: 'SelecionadosSetimaFaseCNH',
    component: () =>
      import(/* webpackChunkName: "SelecionadosSetimaFaseCNH" */ '../views/SelecionadosSetimaFaseCNH.vue'),
    meta: {
      title: 'Selecionados Sétima Fase CNH Social 2022',
    },
  },
  {
    path: '/selecionados-primeira-fase-cnh-2023',
    name: 'SelecionadosPrimeiraFaseCNH2023',
    component: () =>
      import(/* webpackChunkName: "SelecionadosPrimeiraFaseCNH2023" */ '../views/SelecionadosPrimeiraFaseCNH2023.vue'),
    meta: {
      title: 'Selecionados Primeira Fase CNH Social 2023',
    },
  },
  {
    path: '/selecionados-primeira-fase-cnh-2024',
    name: 'SelecionadosPrimeiraFaseCNH2024',
    component: () =>
      import(/* webpackChunkName: "SelecionadosPrimeiraFaseCNH2024" */ '../views/SelecionadosPrimeiraFaseCNH2024.vue'),
    meta: {
      title: 'Selecionados Primeira Fase CNH Social 2024',
    },
  },
  {
    path: '/selecionados-primeira-fase-cnh-2025',
    name: 'SelecionadosPrimeiraFaseCNH2025',
    component: () =>
        import(/* webpackChunkName: "SelecionadosPrimeiraFaseCNH2025" */ '../views/SelecionadosPrimeiraFaseCNH2025.vue'),
    meta: {
      title: 'Selecionados Primeira Fase CNH Social 2025',
    },
    beforeEnter: require2025Timer,
  },
    {
        path: '/selecionados-segunda-fase-cnh-2025',
        name: 'SelecionadosSegundaFaseCNH2025',
        component: () =>
            import(/* webpackChunkName: "SelecionadosPrimeiraFaseCNH2025" */ '../views/SelecionadosSegundaFaseCNH2025.vue'),
        meta: {
            title: 'Selecionados Segunda Fase CNH Social 2025',
        },
        beforeEnter: require2025Timer,
    },
  // {
  //   path: '/testes',
  //   name: 'Testes',
  //   component: () => import(/* webpackChunkName: "testes" */ '../views/Testes.vue'),
  //   meta: {
  //     title: 'Testes',
  //   },
  // },
  {
    path: '/videos',
    name: 'Vídeos',
    component: () => import(/* webpackChunkName: "videos" */ '../views/Videos.vue'),
    meta: {
      title: 'Vídeos',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'Home' },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = `${process.env.VUE_APP_TITLE} - ${to.meta.title}`;
  if (to.path.indexOf('cadastro') > -1) {
    await actionsGeral.setStep(0);
    await actionsCandidate.reset();
  }
  next();
});

export default router;
